export const isKeyPressed = (event, targetKey, fallbackKeyCode) => {
  return (event === null || event === void 0 ? void 0 : event.key) === targetKey || (event === null || event === void 0 ? void 0 : event.keyCode) === fallbackKeyCode;
};
//# sourceMappingURL=isKeyPressed.js.map